export const ADMIN_SESSION_EXPIRED_EVENT = "admin:session-expired";

export class AdminApiError extends Error {
  public readonly status: number;
  public readonly data: unknown;

  constructor(status: number, message: string, data?: unknown) {
    super(message);
    this.name = "AdminApiError";
    this.status = status;
    this.data = data;
  }
}

export function extractErrorMessage(data: unknown, fallback: string): string {
  if (typeof data === "string" && data.trim().length > 0) {
    return data;
  }

  if (data && typeof data === "object") {
    const record = data as Record<string, unknown>;
    const message =
      record.message ?? record.error ?? record.detail ?? record.ErrorMessage ?? record.Description;

    if (typeof message === "string" && message.trim().length > 0) {
      return message.trim();
    }
  }

  return fallback;
}

export function emitSessionExpired(status: number) {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(ADMIN_SESSION_EXPIRED_EVENT, { detail: { status } }));
}
